module.exports = __webpack_public_path__ + "img/组2(1).37e1cd52.png";